module.exports = __webpack_public_path__ + "static/img/kj-ic01.24c6651.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/kj-ic01.png
// module id = UzaJ
// module chunks = 19